import classes from './FlexColumnDiv.module.css';

const FlexColumnDiv = (props) => {
    return (
        <div className={classes.flexColumn}>{props.children}</div>
    )
};

export default FlexColumnDiv;